"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Spacer_1 = __importDefault(require("../../Spacer/Spacer"));
const Search = ({ children, clearFunction, onChange, searchWord, autoFocus, onFocus, placeholder, size, disabled, onKeyPress, onKeyDown, maxLength, }) => {
    const searchClassName = classnames_1.default({
        'form-control': true,
        'search': true,
        'small': size === 'small',
    });
    const buttonClassName = classnames_1.default({
        'btn-search': true,
        'searching': searchWord !== '',
        'small': size === 'small',
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "search-field" },
            React.createElement("input", Object.assign({ type: "search" }, (autoFocus ? { autoFocus: true } : {}), { value: searchWord, className: searchClassName, placeholder: placeholder ? placeholder : 'Filter...', onChange: onChange, disabled: disabled, onKeyPress: onKeyPress, onKeyDown: onKeyDown, onFocus: onFocus, maxLength: maxLength })),
            React.createElement("button", { type: 'button', className: buttonClassName, onClick: clearFunction, disabled: disabled })),
        children && (React.createElement(React.Fragment, null,
            React.createElement(Spacer_1.default, { size: "xxs" }),
            React.createElement("div", { className: "filter-group" }, children)))));
};
exports.Search = Search;
//# sourceMappingURL=Search.js.map